import { IActivityData } from './types';

export const activityDataByYear: {[key: string]: IActivityData} = {
  '2022-2023': {
    activityPoints: 20,
    maxCouncilChoiceActivityPoints: 80,
    supremeFeaturedProgramPoints: 40,
    graphTicks: [0, 20, 40, 60, 80, 100]
  },
  '2023-2024': {
    activityPoints: 25,
    maxCouncilChoiceActivityPoints: 75,
    maxFaithInActionActivityPoints: 100,
    maxTotalFaithInActionAndCouncilChoiceActivityPoints: 125,
    maxChurchDriveActivityPoints: 50,
    ofTheYearPoints: 50,
    graphTicks: [0, 25, 50, 75, 100, 125, 150, 175, 200]
  },
  '2024-2025': {
    activityPoints: 25,
    maxCouncilChoiceActivityPoints: 75,
    maxFaithInActionActivityPoints: 100,
    maxTotalFaithInActionAndCouncilChoiceActivityPoints: 125,
    maxChurchDriveActivityPoints: 50,
    ofTheYearPoints: 50,
    graphTicks: [0, 25, 50, 75, 100, 125, 150, 175, 200]
  },
  '2025-2026': {
    activityPoints: 20,
    administrativeActivityPoints: 25,
    maxCouncilChoiceActivityPoints: 40,
    maxFaithInActionActivityPoints: 80,
    maxTotalFaithInActionAndCouncilChoiceActivityPoints: 80,
    maxMembershipFraternalBenefitActivityPoints: 40,
    ofTheYearPoints: 20,
    supremeFeaturedProgramPoints: 40,
    graphTicks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
  }
};

export function valueOrZero(value: number) {
  return value ? value : 0;
}

export function getProgramValues(
  programGroup: string,
  councilGradingStatDoc: { get: (key: string) => number },
  activityData: IActivityData
): { [x: string]: number } {
  if (programGroup !== 'membership' && programGroup !== 'administrative') {
    const MAX_COUNCIL_CHOICE_ACTIVITY_POINTS = activityData.maxCouncilChoiceActivityPoints ?? 0;
    const MAX_FAITH_IN_ACTION_ACTIVITY_POINTS = activityData.maxFaithInActionActivityPoints ?? 0;
    const MAX_FAITH_IN_ACTION_AND_COUNCIL_CHOICE_ACTIVITY_POINTS = activityData.maxTotalFaithInActionAndCouncilChoiceActivityPoints ?? 0;
    const MAX_OF_THE_YEAR_ACTIVITY_POINTS = activityData.ofTheYearPoints ?? 0;

    let faithInActionPoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-faith-in-action-total-points'));
    let councilChoicePoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-council-choice-total-points'));
    let ofTheYearPoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-of-the-year-total-points'));

    if (faithInActionPoints > MAX_FAITH_IN_ACTION_ACTIVITY_POINTS) { faithInActionPoints = MAX_FAITH_IN_ACTION_ACTIVITY_POINTS; }
    if (councilChoicePoints > MAX_COUNCIL_CHOICE_ACTIVITY_POINTS) { councilChoicePoints = MAX_COUNCIL_CHOICE_ACTIVITY_POINTS; }
    if (ofTheYearPoints > MAX_OF_THE_YEAR_ACTIVITY_POINTS) { ofTheYearPoints = MAX_OF_THE_YEAR_ACTIVITY_POINTS; }

    let faithInActionPointsPlusCouncilChoicePoints = faithInActionPoints + councilChoicePoints;
    if (faithInActionPointsPlusCouncilChoicePoints > MAX_FAITH_IN_ACTION_AND_COUNCIL_CHOICE_ACTIVITY_POINTS) {
      faithInActionPointsPlusCouncilChoicePoints = MAX_FAITH_IN_ACTION_AND_COUNCIL_CHOICE_ACTIVITY_POINTS;
    }

    return {
      [`${programGroup}-faith-in-action-total-points`]: faithInActionPoints,
      [`${programGroup}-council-choice-total-points`]: councilChoicePoints,
      [`${programGroup}-of-the-year-total-points`]: ofTheYearPoints,
      [`${programGroup}-total-points`]: faithInActionPointsPlusCouncilChoicePoints + ofTheYearPoints
    };
  } else if (programGroup === 'membership') {
    const MAX_GROWTH_DRIVE_ACTIVITY_POINTS = activityData.activityPoints ?? 0;
    const MAX_MEMBERSHIP_COUNCIL_CHOICE_POINTS = activityData.activityPoints ?? 0;
    const MAX_EXEMPLIFICATION_ACTIVITY_POINTS = activityData.activityPoints ?? 0;
    const MAX_BENEFITS_NIGHT_ACTIVITY_POINTS = activityData.maxMembershipFraternalBenefitActivityPoints ?? 0;

    let growthDrivePoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-growth-drive-total-points'));
    let councilChoicePoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-council-choice-total-points'));
    let exemplificationPoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-exemplification-total-points'));
    let benefitsNightPoints = valueOrZero(councilGradingStatDoc.get(programGroup + '-benefits-night-total-points'));
    let growthPercentage = valueOrZero(councilGradingStatDoc.get(programGroup + '-growth-percentage-total-points'));

    if (growthDrivePoints > MAX_GROWTH_DRIVE_ACTIVITY_POINTS) { growthDrivePoints = MAX_GROWTH_DRIVE_ACTIVITY_POINTS; }
    if (councilChoicePoints > MAX_MEMBERSHIP_COUNCIL_CHOICE_POINTS) { councilChoicePoints = MAX_MEMBERSHIP_COUNCIL_CHOICE_POINTS; }
    if (exemplificationPoints > MAX_EXEMPLIFICATION_ACTIVITY_POINTS) { exemplificationPoints = MAX_EXEMPLIFICATION_ACTIVITY_POINTS; }
    if (benefitsNightPoints > MAX_BENEFITS_NIGHT_ACTIVITY_POINTS) { benefitsNightPoints = MAX_BENEFITS_NIGHT_ACTIVITY_POINTS; }
    if (growthPercentage >= 200) {
      // Double star gets extra 25 points
      growthPercentage = 125;
    } else if (growthPercentage > 100) {
      growthPercentage = 100;
    }

    const totalPoints = growthDrivePoints + councilChoicePoints + exemplificationPoints + benefitsNightPoints + growthPercentage;

    return {
      [`${programGroup}-growth-drive-total-points`]: growthDrivePoints,
      [`${programGroup}-council-choice-total-points`]: councilChoicePoints,
      [`${programGroup}-exemplification-total-points`]: exemplificationPoints,
      [`${programGroup}-benefits-night-total-points`]: benefitsNightPoints,
      [`${programGroup}-growth-percentage-total-points`]: growthPercentage,
      [`${programGroup}-total-points`]: totalPoints
    };
  } else {
    // Administrative
    // TODO: Need to handle this
    return {[`${programGroup}-total-points`]: 0};
  }
}
